import {isBlank} from '../../../utils/utils';
import {isNull} from 'lodash';
import {entryHasOverrideToOffer} from '../../../reducers/PatEligibilityReducer';

export default function compareVehicles(left, right) {
    if (left === null && right === null) {
        return true
    }

    if (left === null || right === null) {
        return false
    }

    return left.runNumber === right.runNumber
        && left.laneNumber === right.laneNumber
        && left.workOrderNumber === right.workOrderNumber
        && left.sblu === right.sblu
        && left.vin === right.vin
        && left.resultType === right.resultType
}

export function resetVehicleDetailInput(vehicles) {
    const index = vehicles.findIndex(vehicle => vehicle.vehicleDetail && !isNull(vehicle.vehicleDetail.input))
    if (index !== -1) {
        vehicles[index].vehicleDetail.input = null
    }
}

// US-Send-to-AS400-2nd, FR-001/FR-006: whether an already-sent vehicle's live sale type selection
// (patEntry) differs from the sale type reference it was actually last sent to AS400 with
// (vehicle.vehicleSaleType) - the baseline settled on in spec.md Clarifications Q1. Only meaningful
// for a vehicle with a live patEntry (i.e. currently under Edit); a discarded/absent entry (Cancel)
// or one offering no override at all is never "changed".
export function isSaleTypeChangedSinceLastSend(vehicle, patEntry) {
    if (!patEntry || !entryHasOverrideToOffer(patEntry)) {
        return false
    }
    const currentSaleTypeRef = patEntry.isReverted ? '' : (patEntry.selectedSaleType?.saleTypeRef ?? '')
    const lastSentSaleTypeRef = vehicle.vehicleSaleType || ''
    return currentSaleTypeRef !== lastSentSaleTypeRef
}

// FR-009: identity comparison independent of position - two vehicle records are the "same vehicle"
// if VIN and work order number both match, regardless of runNumber/laneNumber. Deliberately separate
// from compareVehicles() (position-based, used elsewhere for list diffing) - not a replacement for it.
export function isSameVehicleIdentity(vehicleA, vehicleB) {
    if (!vehicleA || !vehicleB) {
        return false
    }
    return vehicleA.vin === vehicleB.vin && vehicleA.workOrderNumber === vehicleB.workOrderNumber
}

// Like the find-and-update-only pattern used elsewhere for draftVehicles (see updateElementInList in
// AssignVehicleList.js), but inserts a new entry when no match is found instead of no-op'ing -
// needed to (re-)add an already-sent vehicle to draftVehicles when its sale type becomes dirty.
// Pure (returns the new array) rather than calling a setState function directly, so a caller can
// upsert/remove several vehicles in a single pass (e.g. one effect reacting to several patEntry
// changes at once) and commit the result with exactly one setState call.
export function upsertElementInList(list, vehicleData, matchFn) {
    const existingIndex = list.findIndex(item => matchFn(item, vehicleData))
    if (existingIndex === -1) {
        return [...list, vehicleData]
    }
    const newList = [...list]
    newList[existingIndex] = {...newList[existingIndex], ...vehicleData}
    return newList
}

// Removes the first entry matching matchFn from list, if present; returns list unchanged (same
// reference) otherwise. Pure - see upsertElementInList above.
export function removeElementFromList(list, vehicleData, matchFn) {
    const existingIndex = list.findIndex(item => matchFn(item, vehicleData))
    if (existingIndex === -1) {
        return list
    }
    return [...list.slice(0, existingIndex), ...list.slice(existingIndex + 1)]
}